import {BrowserAnimationsModule} from '@angular/platform-browser/animations'; // this is needed!
import {NgModule} from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {ToastrModule} from 'ngx-toastr';
import {MAT_DATE_LOCALE} from '@angular/material/core';

import {AppComponent} from './app.component';

import {CoreModule} from './core/core.module';
import {LayoutModule} from './layout/layout.module';
import {SharedModule} from './shared/shared.module';
import {RoutesModule} from './routes/routes.module';
import {SharedMaterialModule} from './shared/shared-material.module';

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule, // required for ng2-tag-input
        CoreModule,
        LayoutModule,
        SharedModule.forRoot(),
        SharedMaterialModule.forRoot(),
        RoutesModule,
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
            closeButton: true,
            timeOut: 4000,
            extendedTimeOut: 2000,
            preventDuplicates: true
        })],
    providers: [
        // Los datepickers de Material muestran y parsean las fechas como dd/mm/aaaa.
        {provide: MAT_DATE_LOCALE, useValue: 'es-AR'},
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideTranslateService({
            loader: provideTranslateHttpLoader({prefix: './assets/i18n/', suffix: '.json'})
        })
    ] })
export class AppModule {
}
